import { render, staticRenderFns } from "./BlockButton.vue?vue&type=template&id=8f387d96"
import script from "./BlockButton.vue?vue&type=script&lang=js"
export * from "./BlockButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports